// extracted by mini-css-extract-plugin
module.exports = {"controls":"wBpBQz","control":"WMSNxH","next":"jU1BNx","prev":"wAVSZh","disabled":"__2uPF"};